import { MouseEvent } from 'react';
import { useSlate } from 'slate-react';
import { useSidebar } from 'app/state/contexts/SidebarContext';
import { insertStyledParagraph } from 'slate/extensions/styled-paragraph';
import { v4 as uuidv4 } from 'uuid';

interface AddStyledParagraphProps {
  isInsideStyledParagraph: boolean;
}

export const AddStyledParagraph = ({ isInsideStyledParagraph }: AddStyledParagraphProps) => {
  const { setStyledParagraph, setIsSidebarOpen } = useSidebar();
  const editor = useSlate();

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (isInsideStyledParagraph) {
      setIsSidebarOpen(7);
    } else {
      const styledParagraphId = uuidv4();
      insertStyledParagraph(editor, styledParagraphId);
      setStyledParagraph({ id: styledParagraphId, connected: true });
      setIsSidebarOpen(7);
    }
  };

  return (
    <div className="styled-paragraph--add-paragraph" onMouseDown={handleClick}>
      <i className="fa-regular fa-rectangle-list" />
    </div>
  );
};
